export const firebaseErrorMap = {
  "APIError: Email address already in use. Please try to log in.":
    "Email address already in use, please try to log in.",
  "APIError: Firebase token verification failed: User not found in backend. Please sign up first.":
    "User not found. Please sign up first.",
  "Email address already in use. Please try to log in.":
    "Email address already in use, please try to log in.",
  "Login Failed: Firebase: Error (auth/account-exists-with-different-credential).":
    "You may already have an account with that email address, please try logging in with the original method you used to sign up.",
  "Organization has reached its maximum number of seats":
    "This organization has reached its maximum number of seats. You have been added to the waitlist.",
  "PlatformInvitation matching query does not exist.":
    "Registration failed. Please check your invitation code and try again.",
  "Firebase: Error (auth/invalid-credential).":
    "Invalid credentials. Please check your password and try again.",
  "Firebase: Error (auth/wrong-password).":
    "Invalid credentials. Please check your password and try again.",
  "Firebase: Error (auth/requires-recent-login).":
    "For security reasons, please log out and log back in before changing your email.",
  "Firebase error: The user with the provided email already exists (EMAIL_EXISTS).":
    "This email is already in use by another account.",
  "Firebase: Error (auth/email-already-in-use).":
    "This email is already in use by another account.",
  "Firebase: Error (auth/invalid-email).": "The email address is not valid.",
  "Firebase: Error (auth/user-token-expired).":
    "Your session has expired. Please log in again.",
};

export const formatFirebaseError = (error: string) => {
  const errorMessageIndex = Object.keys(firebaseErrorMap).findIndex((key) =>
    key.includes(error)
  );

  if (errorMessageIndex !== -1) {
    return Object.values(firebaseErrorMap)[errorMessageIndex];
  }

  console.error("Unhandled error:", error);

  return "An error occurred. Please try again.";
};
